export enum SpinnerBorderRadius {
  None = 0,
  Landing = 10,
  Chart = 4,
}
